import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import locale from 'element-plus/lib/locale/lang/zh-cn';
import request from "@/utils/jcRequest";
import I18n from './i18n';
import { ElNotification } from 'element-plus';

import Debounced from '@/utils/tool';
// 这里监听请求的错误统一处理（做弹窗提示提示）


const showMsg = () =>{
   ElNotification({
      title: '接口请求失败',
      message: '服务器链接错误,请稍后重试！',
    });
 };
const debouncedUse: Function = new Debounced().use(showMsg, 1000);
request.on("HttpStatusFaild", () => {
   // console.log("Capture status");
   debouncedUse();
});
createApp(App).use(store).use(router).use(ElementPlus, {locale}).use(I18n).mount('#app');
